<template>
    <div class="container bg-darkGrey">
        <div class="outer">
            <transition appear name="fadeSlow">
                <img class="trainingImage" :src="'images/'+imageDir+'/'+image" :key="image">
            </transition>
        </div>
        
    </div>
</template>

<script>
export default {
    name: "TrainingImage",
    data() {
        return {
            imageDir: "training"
        };
    },
    computed: {
    },
    props: {
        image: {
            type: String,
            required: true
        },
        isAnimating: {
            type:Boolean,
            default: false
        }
    },
};
</script>

<style scoped>
.container {
    display: inline-block;
    position: absolute;
    z-index:3;
    left:0%;
    top:5%;
    width: 99%;
    height: 50%;
    border-radius:14px;
    background: rgba(255, 217, 0, 1);
    background: -moz-linear-gradient(
        top,
        rgba(255, 217, 0, 1) 0%,
        rgba(255, 217, 0, 1) 54%,
        rgba(255, 153, 0, 1) 75%,
        rgba(219, 88, 0, 1) 100%
    );
    background: -webkit-gradient(
        left top,
        left bottom,
        color-stop(0%, rgba(255, 217, 0, 1)),
        color-stop(54%, rgba(255, 217, 0, 1)),
        color-stop(75%, rgba(255, 153, 0, 1)),
        color-stop(100%, rgba(219, 88, 0, 1))
    );
    background: -webkit-linear-gradient(
        top,
        rgba(255, 217, 0, 1) 0%,
        rgba(255, 217, 0, 1) 54%,
        rgba(255, 153, 0, 1) 75%,
        rgba(219, 88, 0, 1) 100%
    );
    background: -o-linear-gradient(
        top,
        rgba(255, 217, 0, 1) 0%,
        rgba(255, 217, 0, 1) 54%,
        rgba(255, 153, 0, 1) 75%,
        rgba(219, 88, 0, 1) 100%
    );
    background: -ms-linear-gradient(
        top,
        rgba(255, 217, 0, 1) 0%,
        rgba(255, 217, 0, 1) 54%,
        rgba(255, 153, 0, 1) 75%,
        rgba(219, 88, 0, 1) 100%
    );
    background: linear-gradient(
        to bottom,
        rgba(255, 217, 0, 1) 0%,
        rgba(255, 217, 0, 1) 54%,
        rgba(255, 153, 0, 1) 75%,
        rgba(219, 88, 0, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffd900', endColorstr='#db5800', GradientType=0 );
}
.outer {
    position: absolute;
    top: 2%;
    left: 1.5%;
    width: 97%;
    height: 95%;
    z-index: 2;
    background: rgba(165, 69, 5, 1);
    background: -moz-linear-gradient(
        top,
        rgba(165, 69, 5, 1) 0%,
        rgba(255, 153, 0, 1) 22%,
        rgba(219, 88, 0, 1) 44%,
        rgba(255, 217, 0, 1) 72%,
        rgba(255, 153, 0, 1) 80%,
        rgba(255, 217, 0, 1) 100%
    );
    background: -webkit-gradient(
        left top,
        left bottom,
        color-stop(0%, rgba(165, 69, 5, 1)),
        color-stop(22%, rgba(255, 153, 0, 1)),
        color-stop(44%, rgba(219, 88, 0, 1)),
        color-stop(72%, rgba(255, 217, 0, 1)),
        color-stop(80%, rgba(255, 153, 0, 1)),
        color-stop(100%, rgba(255, 217, 0, 1))
    );
    background: -webkit-linear-gradient(
        top,
        rgba(165, 69, 5, 1) 0%,
        rgba(255, 153, 0, 1) 22%,
        rgba(219, 88, 0, 1) 44%,
        rgba(255, 217, 0, 1) 72%,
        rgba(255, 153, 0, 1) 80%,
        rgba(255, 217, 0, 1) 100%
    );
    background: -o-linear-gradient(
        top,
        rgba(165, 69, 5, 1) 0%,
        rgba(255, 153, 0, 1) 22%,
        rgba(219, 88, 0, 1) 44%,
        rgba(255, 217, 0, 1) 72%,
        rgba(255, 153, 0, 1) 80%,
        rgba(255, 217, 0, 1) 100%
    );
    background: -ms-linear-gradient(
        top,
        rgba(165, 69, 5, 1) 0%,
        rgba(255, 153, 0, 1) 22%,
        rgba(219, 88, 0, 1) 44%,
        rgba(255, 217, 0, 1) 72%,
        rgba(255, 153, 0, 1) 80%,
        rgba(255, 217, 0, 1) 100%
    );
    background: linear-gradient(
        to bottom,
        rgba(165, 69, 5, 1) 0%,
        rgba(255, 153, 0, 1) 22%,
        rgba(219, 88, 0, 1) 44%,
        rgba(255, 217, 0, 1) 72%,
        rgba(255, 153, 0, 1) 80%,
        rgba(255, 217, 0, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a54505', endColorstr='#ffd900', GradientType=0 );
}
.trainingImage {
    position:absolute;
    width:98%;
    height:96%;
    left:1%;
    top:2%;
}
</style>
